// extracted by mini-css-extract-plugin
module.exports = {"title":"az_TNc","separator":"az_UNc"};